import React, { useState } from "react";
import apiRoutes from "../../../api/apiRoutes";
import { appFetchJson } from "../../../utils/http";

export default function EliminarImpuesto({
  registro = {},
  onClose = () => {},
  onDeleted = () => {},
}) {
  const [loading, setLoading] = useState(false);
  // ELIMINADO: const [error, setError] = useState(""); 
  // Ya no gestionamos el error localmente para no duplicar el mensaje global.

  // Helper simple para mostrar la fecha sin la hora en el resumen
  const formatDate = (dateStr) => {
    if (!dateStr) return "—";
    if (typeof dateStr === "string" && dateStr.includes("T")) {
        return dateStr.split("T")[0];
    }
    return dateStr;
  };

  const handleDelete = async () => {
    // setError(""); // ELIMINADO
    setLoading(true);

    try {
      const id = registro.id;
      if (!id) throw new Error("ID de certificado no encontrado.");

      const url = apiRoutes.certificados.deleteUrl(id);
      
      await appFetchJson(url, { method: "DELETE" });

      onDeleted();
      onClose();
    } catch (e) {
      console.error("Error al eliminar:", e);
      // ELIMINADO: Toda la lógica de setear el mensaje 'msg' en setError.
      // Asumimos que appFetchJson o el interceptor global ya muestra el Alert/Toast.
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="w-full">
      <div className="px-6 py-4 border-b">
        <h2 className="section-title">Eliminar Certificado</h2>
      </div>

      <div className="px-6 pt-4">
        <div className="mb-4 px-4 py-3 text-sm text-blue-600">
          ¿Está seguro que desea eliminar este certificado?
        </div>

        <div className="bg-gray-50 px-6 py-6 mb-2 space-y-2">
          <div>
            <span className="text-gray-500 mr-1">Nro. Certificado:</span>
            <span className="font-medium">{registro.numero ?? "—"}</span>
          </div>

          <div>
            <span className="text-gray-500 mr-1">Fecha del Certificado:</span>
            <span className="font-medium">{formatDate(registro.data)}</span>
          </div>
        </div>
        
        {/* ELIMINADO: El bloque que renderizaba {error && ...} */}

      </div>

      <div className="px-6 py-4 border-t flex gap-2 modal-footer">
        <button className="btn-fil" onClick={handleDelete} disabled={loading}>
          {loading ? "Eliminando…" : "Eliminar"}
        </button>

        <button className="btn-fil" onClick={onClose}>
          Cancelar
        </button>
      </div>
    </div>
  );
}